import { PostItemFragment, ThirdPartyProfileSearchType } from '../../../models/graphql';
import { BaseMention } from '../../../models/slate-editor';
import { deserializeText, serializeTextForQueue } from '../../../modules/PostEditor/TextEditor/helpers/serializer';
import { mapFetchedLinkToPostEditorLink } from '../../../modules/PostEditor/helpers/mapFetchedPostsToState';

export const getCardText = (post: PostItemFragment): string => {
  let method: ThirdPartyProfileSearchType | null;
  switch (post.socialProfile.__typename) {
    case 'FacebookSocialProfile': {
      method = post.socialProfile.type === 'page' ? ThirdPartyProfileSearchType.FACEBOOK_PAGE : null;
      break;
    }
    case 'LinkedInSocialProfile': {
      method = post.socialProfile.type === 'company' ? ThirdPartyProfileSearchType.LINKEDIN_COMPANY : null;
      break;
    }
    case 'TwitterSocialProfile': {
      method = ThirdPartyProfileSearchType.TWITTER_USER;
      break;
    }
    default: {
      method = null;
    }
  }
  const baseMentions = post.mentions.map<BaseMention>(mention => ({ ...mention, method }));

  const deserializedText = deserializeText(
    post.variationMeta?.currentVariation.text || '',
    baseMentions,
    mapFetchedLinkToPostEditorLink(post.link || null)
  );
  return serializeTextForQueue(deserializedText);
};
